import { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { cookiesKeyNames } from '@revbox/common-fe'

import CustomToggle from './CustomToggle'
import AccountsModal from './AccountsModal'

import { useCookiesContext } from '../../contexts/CookiesContext'
import { getMe } from '../../services/micro'
import { setUser } from '../../features/user'
import { skinDropdownTranslates } from '@revbox/localization'

export default function SkinDropdown({ user, userAccesses }) {
    const [modalShow, setModalShow] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { cookiesData, updateCookiesProperty, getPathKey, getToken, getSkinMode, getPublisherId, isDarkMode, isAdvertiser, getLanguageAbbr } = useCookiesContext()

    const handleSkinMode = skin => {
        updateCookiesProperty(cookiesKeyNames.skinMode, skin, getPathKey())

        const HTMLTag = document.querySelector('html')
        if (skin === 'dark') {
            HTMLTag.setAttribute('data-skin', skin)
        } else {
            HTMLTag.removeAttribute('data-skin')
            HTMLTag.removeAttribute('data-sidebar')
        }
    }

    const openMailCatcher = () => {
        window.open('https://mailcatcher.revbox.co/')
    }

    const openAdminPanel = () => {
        const token = getToken()
        const skin = getSkinMode()

        window.open('https://admin.revbox.co?token=' + token + '&skin=' + skin, '_blank')
    }

    const systemMode = (buttonName) => {
        const HTMLTag = document.querySelector('html')

        HTMLTag.removeAttribute('data-sidebar')

        if (buttonName !== undefined && buttonName !== 'advertiser') {
            HTMLTag.setAttribute('data-sidebar', buttonName)
            updateCookiesProperty(cookiesKeyNames.sidebarSkin, buttonName)
        }

        if (buttonName === 'advertiser') {
            setModalShow(true)
        } else {
            const publisher_token = cookiesData[getPathKey()]?.[cookiesKeyNames.publisherToken]
            const publisher_id = getPublisherId()

            getMe(publisher_token)
                .then(res => {
                    dispatch(setUser(res.data))

                    updateCookiesProperty(cookiesKeyNames.token, publisher_token, 'pub')
                    updateCookiesProperty(cookiesKeyNames.publisherId, publisher_id, 'pub')

                    setModalShow(false)

                    if (user.role !== 'developer' && user.role !== 'content_manager' && user.role !== 'sales') {
                        navigate('/pub/dashboard/revenue?pub=' + publisher_id)
                    } else {
                        navigate('/pub/inventory/queue?pub=' + publisher_id)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
    const language = getLanguageAbbr()
    const languageTranslates = skinDropdownTranslates[language]

    return (
        <>
            <Dropdown className="dropdown-skin ms-3" align="end">
                <Dropdown.Toggle as={CustomToggle}>
                    <i className="ri-settings-3-line"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="mt-10-f header-dropdown-menu">
                    <label>{languageTranslates?.skin}</label>
                    <nav className="nav nav-skin">
                        <button onClick={() => handleSkinMode('light')} className={isDarkMode() ? 'nav-link' : 'nav-link active'}>
                            {languageTranslates?.light}
                        </button>
                        <button onClick={() => handleSkinMode('dark')} className={isDarkMode() ? 'nav-link active' : 'nav-link'}>
                            {languageTranslates?.dark}
                        </button>
                    </nav>
                    {isAdvertiser() && user.role != 'CUSTOMER' && (
                        <>
                            <hr />
                            <label>{languageTranslates?.systemMode}</label>
                            <nav id="systemMode" className="nav nav-skin">

                                <button onClick={() => systemMode('publisher')} className="nav-link">
                                    {languageTranslates?.publisher}
                                </button>

                                {(user.role === 'PUBLISHER' || user.role === 'ADMIN' || user.role === 'owner' || user.role === 'full_admin') && (
                                    <button onClick={() => systemMode('advertiser')} className={isAdvertiser() ? 'nav-link active' : 'nav-link'}>
                                        {languageTranslates?.advertiser}
                                    </button>
                                )}
                            </nav>
                        </>
                    )}
                    {!isAdvertiser() && (
                        <>
                            <hr />
                            <label>{languageTranslates?.systemMode}</label>
                            <nav id="systemMode" className="nav nav-skin">
                                <button className="nav-link active">{languageTranslates?.publisher}</button>
                                {userAccesses?.includes('advertiser_access') && (
                                    <button onClick={() => systemMode('advertiser')} className={isAdvertiser() ? 'nav-link active' : 'nav-link'}>
                                        {languageTranslates?.advertiser}
                                    </button>
                                )}
                            </nav>
                        </>
                    )}
                    {
                        user.role === 'ADMIN' && (
                            <>
                                <hr />
                                <label>{languageTranslates?.adminTools}</label>
                                <nav id="systemMode" className="nav nav-skin">
                                    <button onClick={openMailCatcher} className="nav-link">
                                        {languageTranslates?.mailCatcher}
                                    </button>
                                    <button onClick={openAdminPanel} className="nav-link">
                                        {languageTranslates?.blockLibrary}
                                    </button>
                                </nav>
                            </>
                    )}
                </Dropdown.Menu>
            </Dropdown>

            {
                modalShow && (
                    <AccountsModal
                        modalShow={modalShow}
                        user={user}
                        navigate={navigate}
                        dispatch={dispatch}
                        setModalShow={setModalShow}
                    />
                )
            }
        </>
    )
}
